import React, { useEffect, useState } from 'react';
import { Button, Spinner } from '@iq/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { setActiveComponentId } from '../../bundles/application';
import {
  fetchProjectAction,
  getProject,
  updateProject,
  downloadProjectZip,
} from '../../bundles/projects';
import { getActiveSite } from '../../bundles/sites';

import Sidebar from '../Sidebar';
import PageHeader from '../PageHeader';

import HeaderSettings from '../PageHeader/HeaderSettings';
import Notifications from '../Notifications';
import ProjectCreateUpdateView from '../ProjectCreateUpdateView';

const BaseViewMach = ({ isTenantAdminView = false, noSiteView = false, className = '' }) => {
  const dispatch = useDispatch();
  const site = useSelector(getActiveSite);
  const params = useParams();
  const { projectId } = params;
  const project = useSelector((state) => getProject(state, projectId));
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (project) return;

    dispatch(fetchProjectAction(projectId));
  }, [dispatch, projectId]);

  const onResetComponent = () => dispatch(setActiveComponentId(null));

  const handleUpdateProject = (updatedProject) => {
    dispatch(
      updateProject({
        id: project.id,
        ...updatedProject,
      })
    );
  };

  const handleClickDownloadZip = () => {
    setIsLoading(true);
    setTimeout(() => {
      dispatch(downloadProjectZip(project));
      setIsLoading(false);
    }, 2000);
  };

  if (project) {
    return (
      <>
        <Sidebar
          projectId={projectId}
          ecProject={project?.ecModel}
        />
        <section className={`base-view ${className}`}>
          <PageHeader
            site={!isTenantAdminView && site}
            title={{
              type: 'string',
              value: project.name,
            }}
            singlePage={true}
            isTenantAdminView={isTenantAdminView}
            dispatchResetComponent={onResetComponent}
          >
            <Notifications />

            <HeaderSettings
              site={site}
              noSiteView={noSiteView}
            />
          </PageHeader>

          <div className="panel">
            <div className="panel-header">
              <span>MIMS Configuration</span>
              <div className="panel-header-button">
                {isLoading && <Spinner />}
                <Button onClick={handleClickDownloadZip}>Download ZIP</Button>
                <ProjectCreateUpdateView
                  title={'Update Project'}
                  onSave={handleUpdateProject}
                  showButtonDownload={false}
                  createUpdateButtonText="Upload new config"
                  project={project}
                />
              </div>
            </div>

            <dl className="mims-config">
              <span>
                <dt>ID</dt>
                <dd>{project.id}</dd>
              </span>

              <span>
                <dt>Name</dt>
                <dd>{project.name}</dd>
              </span>

              <span>
                <dt>MIMS IP</dt>
                <dd>{project.ip}</dd>
              </span>
            </dl>
          </div>
        </section>
      </>
    );
  }

  return null;
};

export default BaseViewMach;
